import Ajax from "base/Ajax";
import Message from "base/Message";
import AjaxConfirmModal from "modals/AjaxConfirmModal";

export default class InvoiceItem {
    constructor($item) {
        this.$item = $item;
        this.id = this.$item.attr("data-invoice");
        this.context = this.$item.attr("data-context");

        this.bindEvents();
    }

    bindEvents() {
        const me = this;

        this.$item.on("click", ".js-send-invoice-email", function () {
            let $this = $(this);
            let emailId = $this.attr("data-email");

            let modal = new AjaxConfirmModal("Are you sure you want to send this email now?", undefined, () => {
                return Ajax.post("billing", "invoices/" + me.id + "/emails/" + emailId + "/send");
            });
            modal.on("success", (email) => {
                new Message("The email has been successfully sent to " + (email.recipients.map((recipient) => recipient.emailAddress).join(", ")), "Email Sent", Message.SUCCESS, {
                    autoHide: false,
                });
                modal.destroy();

                // Disable button to avoid re-sending
                $this.attr("disabled", true);
            });
            modal.show();

            return false;
        }).on("click", ".js-dismiss-po-warning", function () {
            let $this = $(this);

            let modal = new AjaxConfirmModal("Are you sure you want to dismiss the missing Purchase Order warning?", undefined, async () => {
                await Ajax.post("billing", "invoices/" + me.id + "/dismiss-po-warning");
            });
            modal.on("success", () => {
                new Message("The missing purchase order warning has been successfully dismissed", "Warning Dismissed", Message.SUCCESS, {
                    autoHide: false,
                });
                modal.destroy();

                // Disable button to avoid re-sending
                $this.attr("disabled", true);
            });
            modal.show();
            return false;
        });
    }

    static findAll() {
        return $(".js-invoice-item").map((_, el) => new InvoiceItem($(el))).get();
    }
}
